var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{staticClass:"transition text-gray-700 absolute top-0 right-0 mr-4 lg:mr-0 mt-4 pointer-events-none",attrs:{"name":"chevron-down"}})
}
var staticRenderFns = []

export { render, staticRenderFns }